module.exports = __webpack_public_path__ + "img/Pattern-03.d2ad61bb.png";